export default "/fonts/Poppins-Thin.ttf?28a146b4b94ed3291986dd31684a8da3";